import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { Link } from "react-router-dom";

const destinations = [
  {
    id: 1,
    name: "South Africa",
    listings: 50,
    image: "/assets/img/destination/destination_1_1.jpg",
  },
  {
    id: 2,
    name: "Egypt",
    listings: 45,
    image: "/assets/img/destination/destination_1_2.jpg",
  },
  {
    id: 3,
    name: "Morocco",
    listings: 40,
    image: "/assets/img/destination/destination_1_3.jpg",
  },
  {
    id: 4,
    name: "Kenya",
    listings: 48,
    image: "/assets/img/destination/destination_1_4.jpg",
  },
  {
    id: 5,
    name: "Tanzania",
    listings: 46,
    image: "/assets/img/destination/destination_1_5.jpg",
  },
  {
    id: 6,
    name: "Tunisia",
    listings: 35,
    image: "/assets/img/destination/destination_1_6.jpg",
  },
  {
    id: 7,
    name: "Ethiopia",
    listings: 32,
    image: "/assets/img/destination/destination_1_7.jpg",
  },
  {
    id: 8,
    name: "Uganda",
    listings: 30,
    image: "/assets/img/destination/destination_1_8.jpg",
  },
  {
    id: 9,
    name: "Senegal",
    listings: 28,
    image: "/assets/img/destination/destination_1_9.jpg",
  },
  {
    id: 10,
    name: "Namibia",
    listings: 25,
    image: "/assets/img/destination/destination_1_10.jpg",
  },
];

const sliderOptions = {
  modules: [EffectCoverflow],
  effect: "coverflow",
  centeredSlides: true,
  slidesPerView: "5",
  initialSlide: 0,
  grabCursor: true,
  loop: true, // Change from "true" to true
  speed: 1500,
  coverflowEffect: {
    rotate: 0,
    stretch: 95,
    depth: 212,
    modifier: 1,
  },
  breakpoints: {
    0: { slidesPerView: 1 },
    576: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
    1200: { slidesPerView: 3 },
  },
};

function DestinationOne() {
  const [cursorActive, setCursorActive] = useState(false);

  useEffect(() => {
    // Add event listeners for hover effect
    const sliderWrap = document.querySelector(".slider-drag-wrap");
    const sliderLink = document.querySelectorAll(".slider-drag-wrap a");

    const handleMouseEnter = () => setCursorActive(true);
    const handleMouseLeave = () => setCursorActive(false);

    if (sliderWrap) {
      sliderWrap.addEventListener("mouseenter", handleMouseEnter);
      sliderWrap.addEventListener("mouseleave", handleMouseLeave);
    }

    sliderLink.forEach((link) => {
      link.addEventListener("mouseenter", () => setCursorActive(false));
      link.addEventListener("mouseleave", () => setCursorActive(true));
    });

    // Clean up event listeners on component unmount
    return () => {
      if (sliderWrap) {
        sliderWrap.removeEventListener("mouseenter", handleMouseEnter);
        sliderWrap.removeEventListener("mouseleave", handleMouseLeave);
      }

      sliderLink.forEach((link) => {
        link.removeEventListener("mouseenter", () => setCursorActive(false));
        link.removeEventListener("mouseleave", () => setCursorActive(true));
      });
    };
  }, []);

  return (
    <div className="position-relative overflow-hidden">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">Top Destination</span>
          <h2 className="sec-title">Popular Destination</h2>
        </div>

        <div className={`slider-drag-wrap ${cursorActive ? "active" : ""}`}>
          <Swiper {...sliderOptions} className="destination-slider">
            {destinations.map((dest) => (
              <SwiperSlide key={dest.id}>
                <div className="destination-box gsap-cursor">
                  <div className="destination-img">
                    <img src={dest.image} alt={dest.name}                     style={{
                      //width: "313px",
                      height: "580px",
                      //objectFit: "cover",
                      borderRadius: "12px",
                    }} />
                    <div className="destination-content">
                      <div className="media-left">
                        <h4 className="box-title text-white">{dest.name}</h4>
                        <span className="destination-subtitle">
                          {dest.listings} Listing
                        </span>
                      </div>
                      {/* <div>
                        <Link to="/destination" className="th-btn style2 th-icon">
                          View All
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default DestinationOne;

//  <img
//                     src={category.imgSrc}
//                     alt={category.title}
//                     loading="lazy"
//                     style={{
//                       width: "313px",
//                       height: "313px",
//                       objectFit: "cover",
//                       borderRadius: "12px",
//                     }}
//                   />
